import { providerApi } from '@/api/ProviderApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useConfirmPatientAppointment = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ appointmentId }: { appointmentId: number }) =>
			providerApi.confirmAppointment(appointmentId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['upcoming-appointment'],
			})
		},
	})
}

export { useConfirmPatientAppointment }
